module.exports = __webpack_public_path__ + "static/media/eedit.a4344b07.png";